import { cx } from "@nju/css";
import { Icon } from "@nju/icons";

interface IOnboardingMembersInfo {
  isActive: boolean;
  isError: boolean;
  badge: string | undefined;
  label?: string;
  testId?: string;
}
export function OnboardingMembersInfoItem({
  isActive,
  isError,
  badge,
  label = "test",
  testId,
}: IOnboardingMembersInfo) {
  return (
    <div
      className={cx(
        "flex items-center gap-2 relative px-3 py-1 rounded-badge from-tablet:px-5 from-tablet:py-2 only-mobile:mt-[5px]",
        {
          "border-solid": isActive,
          "text-white border-daintree bg-daintree border-2":
            isActive && !isError,
          "border-solid border-darkBlue border-1 opacity-50": !isActive,
          "border-1 border-solid text-tiaMaria border-tiaMaria bg-white":
            isError,
        },
      )}
      data-cy={testId}
    >
      {isError && <Icon className="w-3 h-3" name="plus-circle" tone="alert" />}
      {label}
      {badge && (
        <span className="absolute top-0 right-3 bg-ripeLemon rounded-badge text-daintree font-bold text-size-12 px-2 py-0 translate-y-[-50%]">
          {badge}
        </span>
      )}
    </div>
  );
}
